/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { JobListFilterDto, JobListItemDto } from '@gh/builder-shared-data';

export type JobFinderListItem = JobListItemDto;

export type JobListFinderFilter = JobListFilterDto;

export const getJobFinderId = (job: JobFinderListItem) => job.id;
